import { render, staticRenderFns } from "./Prodotto.vue?vue&type=template&id=44c8b24c&"
import script from "./Prodotto.vue?vue&type=script&lang=js&"
export * from "./Prodotto.vue?vue&type=script&lang=js&"
import style0 from "./Prodotto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports